import { useStore } from 'vuex'
import { computed, h } from 'vue'
import { message } from 'ant-design-vue'
import CloseImg from '../images/tips-close-img.png'
import WarningImg from '../images/warning.png'
import importantTips from '../images/important-tips.png'

message.config({
  top: `20px`,
  maxCount: 1,
})

export default function useUtils() {
  const store = useStore()
  const languageInfoList = computed(() => store.state.user.languageInfoList)
  const industryTreeList = computed(() => store.state.user.industryTreeList)

  const getLanguageName = (id) => {
    if (!languageInfoList.value) return '' // 避免接口返回null造成下面find函数报错，前端页面crash掉（2021.8.5 dev环境发生过一次）
    const item = languageInfoList.value.find((res) => res.languageId == id)
    if (item) {
      return item.languageName
    } else {
      return ''
    }
  }

  const getIndustryName = (id) => {
    if (!industryTreeList.value) return ''
    const item = industryTreeList.value.find(
      (res) => res.industryId == id || res.oldIndustryId == id
    )
    if (item) {
      return item.industryName
    } else {
      return ''
    }
  }

  const timestampToTimeYMD = (timestamp) => {
    var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '年'
    const M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '月'
    const D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日'
    return Y + M + D
  }

  const timestampToTimeMDEnglish = (timestamp) => {
    var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '/'
    const M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '/'
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    return M + D
  }

  const timestampToTimeYMDHMS = (timestamp) => {
    var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = date.getFullYear() + '-'
    const M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-'
    const D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    const h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    const m =
      (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      ':'
    const s =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
  }

  const thousandBitSeparator = (number) => {
    if (number === '' || number === null || number === undefined) return ''
    let separatingSymbol = ',' //分隔符
    var numpart = String(number).split('.')
    for (let i = 0; i < numpart.length; i++) {
      numpart[i] = numpart[i].replace(
        new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'),
        `$1${separatingSymbol || ''}`
      )
    }
    return numpart.join('.')
  }

  const msgOpen = (contentMsg, tab, name = '') => {
    const userInfo = computed(() => store.state.user.userInfo)
    const accountType = userInfo.value.accountType
    return message.open({
      content: h(
        'span',
        {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
        [
          h('img', {
            style: {
              fontSize: '16px',
              color: '#F55C3F',
              marginRight: '5px',
              width: '16px',
              height: '16px',
            },
            src: WarningImg,
          }),
          h(
            'span',
            {
              style: {
                fontSize: '14px',
                color: '#333',
                marginRight: '20px',
              },
            },
            contentMsg
          ),
          h(
            'span',
            {
              style: {
                padding: 0,
                fontSize: '14px',
                color: 'var(--primary-color)',
                cursor: 'pointer',
              },
              onClick: () => {
                if (accountType === 'enterprise') {
                  message.error(
                    '私有用户暂不支持升级操作，请联系企业创建人处理'
                  )
                  return
                }
                window.open(
                  '/go/tsp_pc_login/home/price?tab=' + (tab || 1),
                  '_blank'
                )
              },
            },
            `${name}`
          ),
          h('img', {
            style: {
              fontSize: '16px',
              color: '#F55C3F',
              marginLeft: '10px',
              width: '16px',
              height: '16px',
              cursor: 'pointer',
            },
            src: CloseImg,
            onClick: () => {
              message.destroy()
            },
          }),
        ]
      ),
      duration: 3,
    })
  }

  const msgUpdate = (contentMsg, name) => {
    return message.open({
      content: h(
        'span',
        {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
        [
          h('img', {
            style: {
              fontSize: '16px',
              color: '#F55C3F',
              marginRight: '5px',
              width: '16px',
              height: '16px',
              animation: 'action 0.8s infinite',
            },
            src: importantTips,
          }),
          h(
            'span',
            {
              style: {
                fontSize: '14px',
                color: '#333',
                marginRight: '20px',
              },
            },
            contentMsg
          ),
          h(
            'span',
            {
              style: {
                padding: 0,
                fontSize: '14px',
                color: '#F55C3F',
                cursor: 'pointer',
              },
              onClick: () => {
                window.location.reload()
              },
            },
            `${name}`
          ),
        ]
      ),
      duration: 0,
    })
  }

  return {
    timestampToTimeMDEnglish,
    getLanguageName,
    getIndustryName,
    timestampToTimeYMD,
    timestampToTimeYMDHMS,
    thousandBitSeparator,
    msgOpen,
    msgUpdate,
  }
}
